module.exports = __webpack_public_path__ + "static/media/P10.7bc09b6d.png";